<template>
    <span class="show-menu-toggle d-none align-center justify-center" @click="isShowMenu=true">
        <font-awesome-icon class="toggle-icon d-block" :icon="['fas', 'fa-bars']" />
    </span>
    <nav class="menu" :class="isShowMenu ? 'active-menu' : null" @click.self="isShowMenu=false">
        <ul class="d-flex align-center gap-25">
            <span class="close-menu d-none position-absolute" @click="isShowMenu=false"><el-icon><Close /></el-icon></span>

            <li v-for="(menu, i) in menus" :key="i">
                <router-link :to="menu.path" @click="isShowMenu=false">{{ menu.name }}</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { Close } from '@element-plus/icons-vue';

export default {
    name: 'NavBar',
    components: {
        Close
    },
    data() {
        return {
            isShowMenu: false,
            menus: [
                {
                    name: 'Traveling',
                    path: '/travel'
                },
                {
                    name: 'Home Decor',
                    path: '/home-decor'
                },
                {
                    name: 'living',
                    path: '/living'
                },
                {
                    name: 'Beaches',
                    path: '/beaches'
                },
                {
                    name: 'Interior',
                    path: '/interior'
                },
                {
                    name: 'Furniture',
                    path: '/furniture'
                }
            ]
        }
    }
}
</script>